import {create} from "zustand";

interface IConsentStore {
  consent: boolean;
  updateConsent: (consent: boolean) => void;
}

export const useConsentStore = create<IConsentStore>((set) => ({
  consent: false,
  updateConsent: (value) => set({consent: value}),
}));
